import '../features/announcementBar/scripts';
import '../features/articleAnchorLinking/scripts';
import '../features/loadMorePaginationButton/scripts';
import '../features/rotatingBanner/scripts';
import '../features/shortQuiz/scripts';
import '../features/viewFullNutrition/scripts';
import '../features/wizard/scripts';
import '../features/wizard-v2/scripts';

